import { cilXCircle } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react';
import * as React from 'react';
import { IImageProvider } from '../abstraction';
import { AppLabels } from '../core/AppLabels';
import { Utils } from '../core/utils';

export interface IActionModel {
	Key: string,			// Code du bouton
	Class: string,			// Classe CSS du bouton
	InlineStyle: string,	// Style css du bouton
	InnerCSS: string,		// Style css du texte bouton (balise span)
	Icon: string,			// Code de l'icône
	Text: string,			// Texte à afficher
	Color: string,			// Couleur bootstrap du bouton
	VisibilityCond: string;		// Bouton visible ou bien non
}

interface IProps {
	isOpen: boolean;				// Indique que la popup est open
	title: string;					// Titre
	choices: IActionModel[];		// Liste des choix possible. Utilise l'interface IActionModel (implémenter par les boutons Actions)
	closeCallBack: (item: IActionModel) => any;	// Call back en cas de clic sur le bouton fermer
	imageProvider: IImageProvider;	// Fournisseur de la méthode getImg() pour les icônes
	vertical?: boolean;				// Indique que les boutons doivent être affichés en liste verticale
}

// Composant représentat une liste de bouton d'action
export class KActionList extends React.Component<IProps> {
	public constructor(props: any) {
		super(props);
	}

	//#region Local events

	// Clic sur bouton de fermeture ou choix
	// code : contient le bouton cliqué ou null si annuler 
	//
	onCloseClick = (code: IActionModel): void => {
		if (this.props.closeCallBack) this.props.closeCallBack(code);
	}

	//#endregion 

	// Rendu de l'image en fonction du code
	// code: identifiant de l'image
	//
	renderImg = (code: string) => {
		if (!code) return "";
		return <img src={this.props.imageProvider.getImg(code)} alt={code} />
	}

	// rendu principal
	//
	render() {
		let css = "";

		// Cette classe permet d'afficher les boutons dans une liste verticale
		// Attention à bien laisser String(...)
		//  En effet, la valeur x3 est une chaine et this.props.vertical a beau être déclaré comme booléan,
		//  son type change à l'exécution et un "if (this.props.vertical == true)" ne serait jamais vrai.
		if (String(this.props.vertical) == "true") css = " VerticalOrientation ";

		// Rien de spécial ici.
		// Une modale avec un titre, les boutons et pis c tout
		return (
			<CModal centered closeOnBackdrop={false} className={"KControlChoice "} show={this.props.isOpen} onClose={() => this.onCloseClick(null)} >
				<CModalHeader closeButton>
					{this.props.title}
				</CModalHeader>

				<CModalBody>
					<div className={"list" + css}>
						{
							this.props.choices.map((action, index) => {

								if (action) {
									let visible = true;
									try {
										// NE PAS Supprimer les variables ci dessous
										// Elles sont à disposition de X3 pour effectuer les eval
										let actions = this.props.choices;

										// NE PAS Supprimer les variables ci dessus

										if (action.VisibilityCond) visible = !eval(action.VisibilityCond);
									}
									catch (err) {
										console.log(err);
									}

									if (visible) {
										let inlineStyle = Utils.decodeInlineStyleFromJson(action.InlineStyle);
										let img = this.renderImg(action.Icon);

										return (
											<CButton key={index} className={action.Class} size="sm" type="submit" role="button" style={inlineStyle} name={action.Key} color={action.Color} onClick={() => this.onCloseClick(action)}>
												{img}
												<span className={action.InnerCSS}>{action.Text}</span>
											</CButton>)
									}
								}
							})
						}
					</div>
				</CModalBody>
				<CModalFooter>
					<CButton color='danger' onClick={() => this.onCloseClick(null)}><CIcon content={cilXCircle} /> {AppLabels.cancel}</CButton>
				</CModalFooter>
			</CModal>
		);
	}
}
